import SelectItem from "@/models/components/inputs/selectItem";
import i18n from "@/plugins/i18n";
import { filterCapitalize } from "@/filters/capitalize";

export enum VALUE_TYPES {
  Unknown = 0,
  Folder = 1000,
  String = 1,
  Int32 = 2,
  Bool = 3,
  Decimal = 4,
  DateTime = 5,
  Enum = 6,
  Currency = 7,
  Date = 8,
  EnumCountry = 9, //autocomplete z backendu
  EnumAirlineName = 10, //autocomplete z backendu
  DecimalDot4 = 11,
  Color = 100,
  BankAccount = 110,
  DefaultBankAccount = 115,
  CreditCard = 120,
  DocumentTemplate = 140,
  ReportSettings = 150,
  MailAccount = 200,
  MailSettings = 210,
  PostalCode = 220,
  SignatureSettings = 300,
}

export const valueTypesSelect: Array<SelectItem> = [
  {
    text: filterCapitalize(i18n.t("notDefined")),
    value: VALUE_TYPES.Unknown,
  },
  {
    text: filterCapitalize(i18n.t("true/false")),
    value: VALUE_TYPES.Bool,
  },
  {
    text: filterCapitalize(i18n.t("text")),
    value: VALUE_TYPES.String,
  },
  {
    text: filterCapitalize(i18n.t("integerNumber")),
    value: VALUE_TYPES.Int32,
  },
  {
    text: filterCapitalize(i18n.t("decimal")),
    value: VALUE_TYPES.Decimal,
  },
  {
    text: filterCapitalize(i18n.t("decimalDot4")),
    value: VALUE_TYPES.DecimalDot4,
  },
  {
    text: filterCapitalize(i18n.t("date")),
    value: VALUE_TYPES.Date,
  },
  {
    text: filterCapitalize(i18n.t("date/time")),
    value: VALUE_TYPES.DateTime,
  },
  {
    text: filterCapitalize(i18n.t("enum")),
    value: VALUE_TYPES.Enum,
  },
  {
    text: filterCapitalize(i18n.t("enumCountry")),
    value: VALUE_TYPES.EnumCountry,
  },
  {
    text: filterCapitalize(i18n.t("enumAirlineName")),
    value: VALUE_TYPES.EnumAirlineName,
  },
  {
    text: filterCapitalize(i18n.t("currency")),
    value: VALUE_TYPES.Currency,
  },
  {
    text: filterCapitalize(i18n.t("color")),
    value: VALUE_TYPES.Color,
  },
  {
    text: filterCapitalize(i18n.t("creditCardNumber")),
    value: VALUE_TYPES.CreditCard,
  },
  {
    text: filterCapitalize(i18n.t("documentTemplate")),
    value: VALUE_TYPES.DocumentTemplate,
  },
  {
    text: filterCapitalize(i18n.t("reportSettings")),
    value: VALUE_TYPES.ReportSettings,
  },
  {
    text: filterCapitalize(i18n.t("mailAccount")),
    value: VALUE_TYPES.MailAccount,
  },
  {
    text: filterCapitalize(i18n.t("mailSettings")),
    value: VALUE_TYPES.MailSettings,
  },
  {
    text: filterCapitalize(i18n.t("postalCode")),
    value: VALUE_TYPES.PostalCode,
  },
  {
    text: filterCapitalize(i18n.t("folder")),
    value: VALUE_TYPES.Folder,
  },
];
